import React, { PropsWithChildren, createContext, useContext } from 'react';

export interface CompactAccordionProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Whether all accordion items are disabled
   */
  disabled?: boolean;
  /**
   * Additional properties
   */
  [key: string]: any;
}

interface AccordionContextValue {
  disabled?: boolean;
}

export const AccordionContext = createContext<AccordionContextValue>({
  disabled: false,
});

export const CompactAccordion: React.FC<PropsWithChildren<CompactAccordionProps>> = ({
  children,
  className = '',
  disabled = false,
  defaultExpandedItems,
  ...rest
}) => {
  const accordionClasses = `core-compact-accordion ${className}`.trim();

  return (
    <AccordionContext.Provider value={{ disabled }}>
      <ul className={accordionClasses} {...rest}>
        {children}
      </ul>
    </AccordionContext.Provider>
  );
};
